import { Grid } from "@mui/material";
import { ReactElement, useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { AppState } from "../reducers";
import { useStyles } from "./styles";
import { loadManagment, resetManagment } from "../actions/managmentActions";
import { loadDriver, resetDriver } from "../actions/driverActions";

import { loadVehicle, resetVehicle } from "../actions/vehicleActions";
import Spinner from "../components/Spinner";
import { setDriverToCary, setIsBusy, setWidthSide, setStateCycle } from "../actions/busyActions";

interface ILayout {
  children: ReactElement;
}

const Layout: React.FC<ILayout> = ({ children }): ReactElement => {

  const classes = useStyles();

  const location = useLocation();

  const [isLoading, setLoading] = useState(false);

  const { isConnected } = useSelector((state: AppState) => state.account);

  const { managment } = useSelector((state: AppState) => state.managment);

  const { drivers } = useSelector((state: AppState) => state.drivers);

  const { vehicles } = useSelector((state: AppState) => state.vehicles);

  const [collapsed, setCollapsed] = useState(false);

  const refSidebar = useRef(document.createElement("div"));

  const dispatch = useDispatch();

  const getCollapseStatus = (isCollapsed: any) => {
    setCollapsed(isCollapsed);
  }

  // const handleResize = () => {
  //   if (window.innerWidth < 1000)
  //     setCollapsed(true);
  //   else setCollapsed(false);
  // }

  // useEffect(() => {
  //   window.addEventListener('resize', (handleResize));
  // }, [collapsed])

  useEffect(() => {
    if (!location.pathname.includes('/paiements')) 
      dispatch(setStateCycle(null));
  }, [dispatch,location])

  const reset = useCallback(async () => {
    if (location.pathname !== '/performance')
      dispatch(await resetManagment());
    if (location.pathname !== '/chauffeurs')
      dispatch(await resetDriver());
    if (location.pathname !== '/vehicules' && !(location.pathname.includes('driver/form'))) {
      dispatch(await resetVehicle());
    }
  }, [dispatch, location])

  useEffect(() => {
    reset();
  }, [reset])

  const firstLoadDataManag = useCallback(async () => {
    dispatch(await loadManagment({}));
  }, [dispatch])

  const firstLoadDataDrivers = useCallback(async () => {
    dispatch(await loadDriver());
  }, [dispatch])

  const firstLoadDataVehicles = useCallback(async () => {
    dispatch(setDriverToCary({}));
    dispatch(await loadVehicle());
  }, [dispatch])



  useEffect(() => {
    if (!['/vehicules', '/chauffeurs'].includes(location.pathname) || location?.state?.originPath !== location.pathname)
      dispatch(setIsBusy(null))
  }, [dispatch, location])

  useEffect(() => {
    if (location.pathname === '/performance') {
      if ((managment && Object.keys(managment)?.length === 0) || !managment) {
        setLoading(true)
        firstLoadDataManag();
      }
    }
  }, [firstLoadDataManag, managment, location]);

  useEffect(() => {
    if (location.pathname === '/chauffeurs') {
      if ((drivers && Object.keys(drivers)?.length === 0) || !drivers) {
        setLoading(true)
        firstLoadDataDrivers();
      }
    }
  }, [firstLoadDataDrivers, drivers, location])

  useEffect(() => {
    if (location.pathname === '/vehicules' || (location.pathname.includes('driver/form'))) {
      if ((vehicles && Object.keys(vehicles)?.length === 0) || !vehicles) {
        setLoading(true);
        firstLoadDataVehicles();
      }
    }
  }, [firstLoadDataVehicles, location, vehicles])

  const handleSizeBar = useCallback(() => {
    dispatch(setWidthSide(refSidebar?.current?.clientWidth))
  }, [refSidebar, dispatch])

  useEffect(() => {
    window.addEventListener('resize', (handleSizeBar))
  }, [handleSizeBar, collapsed])

  useEffect(() => {
    dispatch(setWidthSide(refSidebar?.current?.clientWidth))
  }, [refSidebar, dispatch, collapsed])

  useEffect(() => {
    if (managment || drivers || vehicles) {
      let myDelay = setTimeout(() => {
        setLoading(false)
      }, 750);
      return () => clearTimeout(myDelay);
    }
  }, [managment, drivers, vehicles])

  return (

    <>
      {isConnected ? <>
        {isLoading && (
          <Spinner />
        )}
        <Grid container xs={12} className={classes.dashboard}>
          <Grid xs={0.7} sm={0.7} md={0.7} lg={collapsed ? 0.7 : 2} className={classes.left_container}>
            <Sidebar isCollapsed={getCollapseStatus} />
          </Grid>
          <Grid xs={11.3} sm={11.3} md={11.3} lg={collapsed ? 11.3 : 10} className={classes.right_container} ref={refSidebar}>
            <Header />
            <> {children} </>
          </Grid>
        </Grid>
      </> : (
        <> {children} </>
      )}
    </>
  );
};

export default Layout;
